function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, memo, useRef } from "react";
import ReactDOM from "react-dom";
import { invariant, hasWindow } from "@rpldy/shared";
import { NoDomUploady, useUploadOptions } from "@rpldy/shared-ui";
// type InputRef =  { current: null | HTMLInputElement, ... } | ((null | HTMLInputElement) => mixed);

const NO_CONTAINER_ERROR_MSG = "Uploady - Container for file input must be a valid dom element";
const renderInput = (inputProps, instanceOptions, ref) => /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
  name: instanceOptions.inputFieldName,
  type: "file",
  ref: ref
}));
const renderInPortal = (container, isValidContainer, inputProps, instanceOptions, ref) => container && isValidContainer ? /*#__PURE__*/ReactDOM.createPortal(renderInput(inputProps, instanceOptions, ref), container) : null;
const FileInputField = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    container,
    noPortal,
    ...inputProps
  } = _ref;
  const instanceOptions = useUploadOptions();
  const isValidContainer = container && container.nodeType === 1;
  invariant(isValidContainer || !hasWindow(), NO_CONTAINER_ERROR_MSG);

  // In DEV - SSR React will warn on mismatch between client&server :( -
  // https://github.com/facebook/react/issues/12615
  // https://github.com/facebook/react/issues/13097
  return noPortal ? renderInput(inputProps, instanceOptions, ref) : renderInPortal(container, isValidContainer, inputProps, instanceOptions, ref);
}));
const Uploady = props => {
  const {
    multiple = true,
    capture,
    accept,
    webkitdirectory,
    children,
    inputFieldContainer,
    customInput,
    fileInputId,
    noPortal = false,
    ...noDomProps
  } = props;
  const container = !customInput ? inputFieldContainer || (hasWindow() ? document.body : null) : null;
  const internalInputFieldRef = useRef();
  return /*#__PURE__*/React.createElement(NoDomUploady, _extends({}, noDomProps, {
    inputRef: internalInputFieldRef
  }), !customInput ? /*#__PURE__*/React.createElement(FileInputField, {
    container: container,
    multiple: multiple,
    capture: capture,
    accept: accept,
    webkitdirectory: webkitdirectory?.toString(),
    style: {
      display: "none"
    },
    ref: internalInputFieldRef,
    id: fileInputId,
    noPortal: noPortal
  }) : null, children);
};
export default Uploady;